export default __webpack_public_path__ + "static/media/ruthsroses-logo.a3ed137f.svg";